import { Component } from '@angular/core';
import { Globals } from 'src/app/common/globals';

@Component({
  selector: 'app-registry-header',
  templateUrl: './registry-header.component.html',
})
export class RegistryHeaderComponent {
  constructor(
    protected globals: Globals
  ) { }
}
